import type { RouteRecordRaw } from 'vue-router';
import { BOOK_APPOINTMENT_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const bookAppointmentRoutes: RouteRecordRaw = {
  path: '/book-appointment',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true, i18n },
  children: [
    {
      path: '',
      alias: 'list',
      name: BOOK_APPOINTMENT_ROUTE_NAME.BOOK_APPOINTMENT,
      component: () => import('./BookAppointment.vue'),
    },
  ],
};
